// extracted by mini-css-extract-plugin
export default {"Files":"styles_Files__kITb5","files":"styles_files__qw-S9","uploader":"styles_uploader__DLOh2","uploadButton":"styles_uploadButton__eRcJy","dropzone":"styles_dropzone__gR7cK"};